export const EMPTY_TITLE_PLACEHOLDER = 'NO TITLE';

export const LOCAL_STORAGE_THEME_KEY = 'currentTheme';
export const LOCAL_STORAGE_TYPOGRAPHY_THEME_KEY = 'currentTypographyTheme';
